import { createContext, useContext, useEffect, useState } from 'react';
import { api, saveToken, clearToken, hasToken } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // We don't have a "whoami" endpoint, so a stored token means "logged in"
    // but the user object is re-populated fresh at login time only. A page
    // reload keeps the token (and API calls keep working) but loses the
    // cached name/role until next login — acceptable for a small utility app.
    const stored = sessionStorage.getItem('honeydo_user');
    if (hasToken() && stored) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  async function login(email, password) {
    const { token, user: loggedInUser } = await api.login(email, password);
    saveToken(token);
    sessionStorage.setItem('honeydo_user', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
    return loggedInUser;
  }

  function logout() {
    clearToken();
    sessionStorage.removeItem('honeydo_user');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
